import { atom } from "recoil";


const personState = atom({
    key: 'currentPerson',
    default: null,
});
  
export default personState